app.controller("ConfirmSelectionWindowController", ["$scope", "$http", "Students", "$uibModalInstance",
    function ($scope, $http, Students, $uibModalInstance) {
        $scope.close = function () {
            $uibModalInstance.close();
        };

        $scope.agree = function () {
            $uibModalInstance.dismiss('confirm');
        };
    }
]);